import { Icon, type IconProps } from '../icon'

type IconDualColorTopProps = Omit<IconProps, 'size'>

export function IconDualColorTop({
  children,
  color = 'colorActionTextOnbrandDefault',
  // @ts-expect-error size prop is taken from IconDualColorRoot
  size,
  // @ts-expect-error disabled prop is taken from IconDualColorRoot
  disabled,
  ...props
}: IconDualColorTopProps) {
  const iconColor = disabled ? 'colorTextNeutralDisabled' : color

  return (
    <Icon
      data-testid="icon-dual-color-top"
      data-icon="top"
      data-size={size}
      color={iconColor}
      size={size}
      {...props}
    >
      {children}
    </Icon>
  )
}

IconDualColorTop.displayName = 'IconDualColorTop'
